import { api } from '@/services'

export function fetchActivePause () {
  return api.get('/admin/appointmentOfferPause/active')
}

export function pause(body) {
  return api.post('/admin/appointmentOfferPause/pause', body)
}

export function resume() {
  return api.post('/admin/appointmentOfferPause/resume')
}
